<template>
	<div class="animated fadeIn">
		<b-card>
			<vue-loading :active.sync="usersTableProps.isLoading" :is-full-page="false"/>
			<vue-loading :active.sync="isLoadingDeleting" :is-full-page="false"/>
			<div slot="header">
				<b>Seznam uporabnikov</b>
				<div class="card-header-actions">
					<CLink title="Osveži tabelo" href="#" class="card-header-action btn-setting" @click.stop="click_usersTableRefresh">
						<CIcon name="cil-loop-circular"/>
					</CLink>
					<CLink title="Ponastavi filtre" href="#" class="card-header-action btn-setting" @click.stop="click_usersTableResetFilters">
						<CIcon name="cil-x"/>
					</CLink>
					<CLink title="Dodaj uporabnika" href="#" class="card-header-action btn-setting" @click.stop="click_userCreate">
						<CIcon name="cil-plus"/>
					</CLink>
				</div>
			</div>
				<b-table
					ref="usersTable"
					responsive="sm"
					striped
					show-empty
					hover
					:empty-text="usersTableProps.empty_text"
					:empty-filtered-text="usersTableProps.empty_filtered_text"
					:fields="usersTableProps.fields"
					:current-page="usersTableProps.currentPage"
					:per-page="usersTableProps.itemsPerPage"
					:items="usersTable_items">
					<template slot="top-row">
							<td></td>
							<td><b-form-input v-model="usersTableProps.inputFilter.name" type="text" @input="usersTableTextFilter_change"/></td>
							<td><b-form-input v-model="usersTableProps.inputFilter.email" type="text" @input="usersTableTextFilter_change"/></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
					</template>
					<template v-slot:cell(roles)="data">
						<CBadge v-for="role in data.item.roles" :key="role.id" color="primary" class="float-right mr-2">{{ role.name }}</CBadge>
					</template>
					<template v-slot:cell(allPermissions)="data">
						<CBadge v-for="permission in data.item.allPermissionsNames" :key="permission.id" color="primary" class="float-right mr-2 mb-1">{{ permission }}</CBadge>
					</template>
					<template v-slot:cell(created_at)="data">
						{{ data.item.created_at | viewDate }}
					</template>
					<template v-slot:cell(actions)="data">
						<div>
							<b-button title="Uredi uporabnika" variant="primary" @click.stop="click_userEdit(data.item)" size="sm" class="mr-2">
								<CIcon name="cil-pencil"/>
							</b-button>
							<b-button title="Izbriši uporabnika" variant="danger" @click.stop="click_userDelete(data.item)" size="sm" class="mr-2">
								<CIcon name="cil-trash"/>
							</b-button>
						</div>
					</template>
				</b-table>
				<nav>
					<b-row>
						<b-col>
							<b-pagination :total-rows="usersTableProps.totalItems" :per-page="usersTableProps.itemsPerPage" v-model="usersTableProps.currentPage" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
						</b-col>
						
						<b-col cols=2>
							<a class="page-link rows_total float-right">Št. vrstic: {{ usersTableProps.totalItems }}</a>
						</b-col>
						<b-col cols=1>
							<b-form-select v-model="usersTableProps.itemsPerPage" :options="usersTableProps.options_numRowsOnPage"></b-form-select>
						</b-col>
					</b-row>
				</nav>
			</b-card>
		<user-create-edit-modal ref="userCreateEditModal" @emit_userCreatedOrEdited="emit_userCreatedOrEdited"/>
		<vue-toastr ref="toastr"></vue-toastr>
	</div>
</template>

<script>
import settings from '@/settings.js';
import UserCreateEditModal from '@/views/modals/UserCreateEdit';
import { USERS_LIST_FILTERED, USER_DELETE } from "@/store/actions/users";

export default {
	name: 'Users',
	components: {
		'user-create-edit-modal': UserCreateEditModal
	},
	data () {
		return {
			usersTableProps: {
				fields: [
					{ key: 'id', label: 'Id', sortable: true, class: 'tdUsersId' },
					{ key: 'name', label: 'Naziv', sortable: true, class: '' },
					{ key: 'email', label: 'Email', sortable: true, class: 'tdUsersEmail' },
					{ key: 'roles', label: 'Vloge', sortable: true, class: 'tdUsersRoles' },
					{ key: 'allPermissions', label: 'Dovoljenja', sortable: true, class: 'tdUsersPermissions' },
					{ key: 'created_at', label: 'Ustvarjen dne', sortable: true, class: 'tdUsersCreatedAt' },
					{ key: 'actions', label: '#', sortable: false, class: 'tdUsersActions' },
				],
				currentPage: 1,
				itemsPerPage: 50,
				totalItems: 0,
				isLoading: false,
				options_numRowsOnPage: [
					{ value: 50, text: '50' },
					{ value: 100, text: '100' },
					{ value: 200, text: '200' },
					{ value: 1000, text: '1000' }
				],
				empty_text: '',
				empty_filtered_text: 'Ni zadetkov',
				inputFilter: {
					name: null,
					email: null
				},
				textFilterTimeout: null,
				errorText: ''
			},
			isLoadingDeleting: false,
			allPossiblePermissions: []
		}
	},
	watch: {
	},
	computed: {
	},
	methods: {
		click_userCreate: function () {
			let modalInput = {
				mode: 1, // create
				modalUser: null
			}
			this.$refs.userCreateEditModal.showModal(modalInput);
		},
		click_userEdit: function (data) {
			let modalInput = {
				mode: 2, // edit
				modalUser: data
			}
			this.$refs.userCreateEditModal.showModal(modalInput);
		},
		click_userDelete: function (data) {
			this.$bvModal.msgBoxConfirm('Želite izbrisati uporabnika ' + data.name + ' (#' + data.id + ')?', {
				title: 'Potrdite brisanje uporabnika',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					this.isLoadingDeleting = true;
					this.$store.dispatch(USER_DELETE, { id: data.id })
						.then((responseData) => {
							this.isLoadingDeleting = false;
							this.$refs.toastr.s('Uporabnik ' + data.name + '(#' + data.id + ') uspešno izbrisan.');
							this.$refs.usersTable.refresh();
						})
						.catch(error => {
							this.isLoadingDeleting = false;
							console.error(error);
							if(error.response && error.response.data && error.response.data.code) {
								this.$refs.toastr.e('Napaka pri brisanju! (' + error.response.data.code + ')');
							} else {
								this.$refs.toastr.e('Napaka pri brisanju! Prosimo poizkusite kasneje.');
							}
						}); 
				}
			}).catch(err => {
				console.error(err);
			})
		},
		click_usersTableRefresh: function () {
			this.$refs.usersTable.refresh();
		},
		click_usersTableResetFilters: function () {
			this.usersTableProps.inputFilter.name = null;
			this.usersTableProps.inputFilter.email = null;
			this.$refs.usersTable.refresh();
		},
		emit_userCreatedOrEdited: function (data) {
			if (data.message === 'created') {
				this.$refs.toastr.s('Uporabnik ' + data.user.name + ' uspešno dodan.');
				this.$refs.usersTable.refresh();
			} else if (data.message === 'edited') {
				this.$refs.toastr.s('Uporabnik ' + data.user.name + ' uspešno urejen.');
				this.$refs.usersTable.refresh();
			} else {
				this.$refs.toastr.e('Neznan odziv strežnika.');
				this.$refs.usersTable.refresh();
			}
		},
		usersTable_items: function (ctx) {
			this.usersTableProps.isLoading = true;
			return this.$store.dispatch(USERS_LIST_FILTERED, { ctx: ctx, tableProps: this.usersTableProps })
				.then((responseData) => {
					this.usersTableProps.isLoading = false;
					this.usersTableProps.items = responseData.usersPagination.data;
					this.usersTableProps.totalItems = responseData.usersPagination.total;
					this.usersTableProps.empty_text = 'Ni vnosov';
					this.allPossiblePermissions = responseData.allPossiblePermissions;
					return responseData.usersPagination.data;
				})
				.catch(error => {
					this.usersTableProps.isLoading = false;
					this.usersTableProps.items = [];
					this.usersTableProps.totalItems = 0;
					this.usersTableProps.empty_text = 'Napaka pri pridobivanju uporabnikov';
					this.allPossiblePermissions = [];
					console.log(error);
					return [];
				});
		},
		usersTableTextFilter_change: function (value) {
			if (this.usersTableProps.textFilterTimeout !== null) {
				clearTimeout(this.usersTableProps.textFilterTimeout);
			}
			this.usersTableProps.textFilterTimeout = setTimeout(() => {
				this.$refs.usersTable.refresh();
			}, settings.filterTimeoutLength);
		},
		
	},
	created: function () {
	}
}
</script>
<style scoped>
.table-responsive-sm {
	margin-bottom: 0;
}
.pagination {
	margin-left: 1rem;
	margin-right: 1rem;
}
.page-link.rows_total {
	text-align: center;
	border-radius: 5px;
	width: 120px;
}
</style>

<style>
.tdUsersId {
	width: 120px;
}
.tdUsersActions {
	width: 120px;
}
.tdUsersEmail {
	width: 220px;
}
.tdUsersRoles {
	width: 220px;
	max-width: 220px;
}
.tdUsersRoles {
	width: 220px;
	max-width: 220px;
}
.tdUsersCreatedAt {
	width: 220px;
}
</style>